import { useEffect, useState } from "react";

import { IMenu } from "@/@types/Header";
import { apiJoomla } from "@/services/api";

import { Link } from "react-router-dom";

// url base para os paths do joomla
const baseUrl = 'https://www.feagri.unicamp.br/portal';

export default function Header() {
  const [menuHorizontalResult, setMenuHorizontalResult] = useState<IMenu[]>([]); // estado que armazenará o resultado da consulta da tabela agrnew_menu do joomla

  useEffect(() => {
    const getMenuHorizontal = async () => {
      const url = '/jmenu/horizontal';

      await apiJoomla.get<IMenu[]>(url)
        .then(({ data }) => {
          setMenuHorizontalResult(data);
        })
        .catch(err => {
          console.log(err);
        });

    }

    getMenuHorizontal();
  }, []);

  return (
    <header>
      <section id="top-bar">
        <div className="container">
          <div className="row">
            <nav id="top-bar-submenu" className="col">
              <ul>
                <li>
                  <a href="https://www.feagri.unicamp.br/acolheagri" target="_blank" className="acolheagri">AcolhEAGRI</a>
                </li>
                <li>
                  <Link to="/extranet/feagri/comunidade">Comunidade</Link>
                </li>
                {/* <li>
                  <a href="https://wiki.feagri.unicamp.br/doku.php?id=feagri.wiki">Wiki</a>
                </li> */}
                <li>
                  <a href="https://email.unicamp.br/">Webmail</a>
                </li>
                <li>
                  <a href="https://www.feagri.unicamp.br/portal/informacoes">Informações</a>
                </li>
                <li>
                  <a href="https://www.feagri.unicamp.br/portal/login">Login do Site</a>
                </li>
              </ul>
              <ul className="lang-inline">
                <li className="lang-active" dir="ltr">
                  <a href="https://www.feagri.unicamp.br/portal/a-pos-graduacao">
                    <img
                      data-src="https://www.feagri.unicamp.br/portal/media/mod_languages/images/pt_br.gif"
                      alt="Portugues (pt-BR)"
                      title="Portugues (pt-BR)"
                      src="https://www.feagri.unicamp.br/portal/media/mod_languages/images/pt_br.gif"
                    />
                  </a>
                </li>
                <li dir="ltr">
                  <a href="https://www.feagri.unicamp.br/portal/en/the-postgraduate">
                    <img
                      data-src="https://www.feagri.unicamp.br/portal/media/mod_languages/images/en.gif"
                      alt="English (UK)"
                      title="English (UK)"
                      src="https://www.feagri.unicamp.br/portal/media/mod_languages/images/en.gif"
                    />
                  </a>
                </li>
                <li dir="ltr">
                  <a href="https://www.feagri.unicamp.br/portal/es/">
                    <img
                      data-src="https://www.feagri.unicamp.br/portal/media/mod_languages/images/es.gif"
                      alt="Espanhol (es-ES)"
                      title="Espanhol (es-ES)"
                      src="https://www.feagri.unicamp.br/portal/media/mod_languages/images/es.gif"
                    />
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </section>

      {/* MENU MOBILE */}
      <section id="mobile-header" className="d-block d-sm-none">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="logos d-flex justify-content-center">
                <a href="http://www.feagri.unicamp.br/portal/">
                  <img
                    className="sp-default-logo"
                    src="https://www.feagri.unicamp.br/portal/images/Logos/lg_feagricompleto_homenova-fdbrc.svg"
                    alt="FEAGRI - Faculdade de Engenharia Agrícola"
                  />
                </a>
                <a href="http://www.unicamp.br/">
                  <img
                    src="https://www.feagri.unicamp.br/portal/images/Logos/logo-unicamp.png"
                    alt="Unicamp"
                  />
                </a>
              </div>

              <div className="block">
                <h3 className="header-menu-title">Menu Principal</h3>
                <ul className="principal" id="main-menu-mobile">
                  <li>
                    <a href="#">Feagri</a>
                  </li>
                  <li>
                    <a href="#">Estude Conosco</a>
                  </li>
                  <li>
                    <a href="#">Acadêmico</a>
                  </li>
                  <li>
                    <a href="#">Pesquisa</a>
                  </li>
                  <li>
                    <a href="#">Vida Universitária</a>
                  </li>
                </ul>
              </div>
              <div className="block">
                <h3 className="header-menu-title">Graduação</h3>
                <ul className="tree-menu">
                  <li className="item-parent has-child">
                    <span className="far fa-plus-square"></span>
                    <a href="#">Graduação</a>
                    <ul className="nested">
                      <li>
                        <a href="#">Objetivo</a>
                      </li>
                      <li>
                        <a href="#">Histórico</a>
                      </li>
                    </ul>
                  </li>
                  <li className="item-parent has-child">
                    <span className="far fa-plus-square"></span>
                    <a href="#">Comissão</a>
                    <ul className="nested">
                      <li>
                        <a href="#">Comissão</a>
                      </li>
                      <li>
                        <a href="#">Composição</a>
                      </li>
                    </ul>
                  </li>
                  <li className="item-parent has-child">
                    <span className="far fa-plus-square"></span>
                    <a href="#">Normas</a>
                    <ul className="nested">
                      <li>
                        <a href="#">Regimento geral (DAC)</a>
                      </li>
                      <li>
                        <a href="#">Regimento interno</a>
                      </li>
                    </ul>
                  </li>

                  <li className="item-parent has-child">
                    <span className="far fa-plus-square"></span>
                    <a href="#">Disciplinas</a>
                    <ul className="nested">
                      <li>
                        <a href="#">Obrigatórias</a>
                      </li>
                      <li>
                        <a href="#">Eletivas</a>
                      </li>
                      <li className="has-child">
                        <span className="far fa-plus-square"></span>
                        <a href="#">Certificados de Estudos</a>
                        <ul className="nested">
                          <li>
                            <a href="#">Comissão</a>
                          </li>
                          <li>
                            <a href="#">Composição</a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li className="item-parent has-child">
                    <span className="far fa-plus-square"></span>
                    <a href="#">Professores</a>
                    <ul className="nested">
                      <li>
                        <a href="#">Calendário Feagri</a>
                      </li>
                      <li>
                        <a href="#">Avaliação do curso</a>
                      </li>
                    </ul>
                  </li>
                  <li className="item-parent has-child">
                    <span className="far fa-plus-square"></span>
                    <a href="#">Alunos</a>
                    <ul className="nested">
                      <li>
                        <a href="#">Avaliação disciplinas</a>
                      </li>
                      <li>
                        <a href="#">Avaliação curso</a>
                      </li>
                    </ul>
                  </li>
                  <li className="item-parent has-child">
                    <span className="far fa-plus-square"></span>
                    <a href="#">Protocolo</a>
                    <ul className="nested">
                      <li>
                        <a href="#">Solicitações</a>
                      </li>
                      <li>
                        <a href="#">Consulta solicitações</a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MENU PRINCIPAL */}
      <section id="main-menu" className="d-none d-sm-block">

        <div className="container">

          <div className="row mx-0">

            {/* LOGO */}
            <section id="logo" className="col-xs-8 col-sm-2 col-md-2">

              <a href="http://www.feagri.unicamp.br/portal/">
                <h1>
                  <img
                    src="https://www.feagri.unicamp.br/portal/images/Logos/lg_feagricompleto_homenova-fdbrc.svg"
                    alt="FEAGRI - Faculdade de Engenharia Agrícola"
                  />
                </h1>
              </a>

            </section>


            <section id="menu" className="col-xs-4 col-sm-9 col-md-9">
              <nav>

                <ul className="megamenu-parent">
                  {menuHorizontalResult.map(menuItem => {
                    if (menuItem.level === 1 && menuItem.title !== 'Home') {
                      return (
                        <>
                          {/* Renderiza todos os itens de menu com level 1, com exceção ao de título 'Home' */}
                          <li key={menuItem.id} className="menu-item has-child">

                            <a href="#">{menuItem.title}</a>

                            <div className="dropdown dropdown-main">

                              <div className="dropdown-inner ">

                                <div className="col-sm-4 w-[100%]">

                                  <ul className={`sp-mega-group flex w-[100%] justify-around flex-wrap ${menuItem.title === 'Pesquisa' && 'flex-col h-[300px] justify-normal'} ${menuItem.title === 'Vida Universitária' && 'flex-col justify-normal'}`}>

                                    {menuHorizontalResult.map(menuItemLevel2 => {
                                      if (menuItemLevel2.level === 2 && menuItemLevel2.parent_id === menuItem.id) {
                                        return (
                                          // renderiza todos os itens de menu de nível 2, relacionados ao item de menu 1
                                          <li key={menuItemLevel2.id} className="item-1091 menu_item item-header">
                                            <a
                                              className="sp-group-title menuTitleLevel2"
                                              href={menuItemLevel2.link === 'index.php?Itemid=' ? `${baseUrl}/${menuItemLevel2.path}` : menuItemLevel2.link} // verifica se é um link completo ou path
                                              target={menuItemLevel2.link === 'index.php?Itemid=' ? '_self' : '_blank'}
                                            >
                                              {menuItemLevel2.title !== '-' && menuItemLevel2.title}
                                            </a>

                                            <ul className="sp-mega-group-child sp-dropdown-items" >

                                              {menuHorizontalResult.map(menuItemLevel3 => {
                                                if (menuItemLevel3.parent_id === menuItemLevel2.id && menuItemLevel3.level === 3) {
                                                  return (
                                                    // renderiza todos os itens de menu de nível 3, relacionados ao item de menu 2
                                                    <li key={menuItemLevel3.id} className="sp-menu-item">
                                                      <a
                                                        href={menuItemLevel3.link === 'index.php?Itemid=' ? `${baseUrl}/${menuItemLevel3.path}` : menuItemLevel3.link} // verifica se é um link completo ou path
                                                        target={menuItemLevel3.link === 'index.php?Itemid=' ? '_self' : '_blank'}
                                                      >
                                                        {menuItemLevel3.title}
                                                      </a>
                                                    </li>

                                                  )
                                                }
                                              })}
                                            </ul>

                                          </li>
                                        )
                                      }
                                    })}
                                  </ul>
                                </div>
                              </div>
                            </div>

                          </li>

                        </>
                      )
                    }
                  })}


                </ul>
              </nav>
            </section>

            {/* LOGO UNICAMP */}
            <section id="logo2" className="col-sm-1 col-md-1">
              <a href="https://www.unicamp.br/">
                <img
                  src="https://www.feagri.unicamp.br/portal/images/Logos/logo-unicamp.png"
                  alt="Unicamp"
                />
              </a>
            </section>

          </div>
        </div>
      </section>
    </header>
  );
}
